import { render, staticRenderFns } from "./ChatMessageView.vue?vue&type=template&id=de2f5fc8&scoped=true"
import script from "./ChatMessageView.vue?vue&type=script&lang=js"
export * from "./ChatMessageView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de2f5fc8",
  null
  
)

export default component.exports